import React from 'react';
import { Col, Row } from 'react-bootstrap';

import AnimatedEmptyBox from '../../ui-library/layout/elements/AnimatedEmptyBox';
import { Cabbage } from '../../ui-library/typography';
import { CenterContentBox } from '../../ui-library/layout';
import { STR_STORE } from '../../utils/constants';
import StyledWideContainer from '../../ui-library/styled/StyledWideContainer';

const GenericEmptyState = () => {
  return (
    <StyledWideContainer style={{ maxWidth: '1200px' }}>
      <CenterContentBox>
        <Cabbage as='h1'>{STR_STORE}</Cabbage>
      </CenterContentBox>
      <Row>
        <Col lg={4} className='mb-4'>
          <AnimatedEmptyBox height='232px' />
        </Col>
        <Col lg={4} className='mb-4'>
          <AnimatedEmptyBox height='232px' />
        </Col>
        <Col lg={4} className='mb-4'>
          <AnimatedEmptyBox height='232px' />
        </Col>
      </Row>
    </StyledWideContainer>
  );
};

export default GenericEmptyState;
